import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/virtualControl',
  component: LAYOUT,
  name: 'VirtualControl',
  redirect: '/virtualControl/x7/index',
  meta: {
    title: '虚拟车控',
  },
  children: [
    {
      path: 'x7/index',
      name: 'VirtualControlX7Index',
      meta: {
        title: '虚拟车控',
      },
      component: () => import('@/views/virtualControl/x7/index'),
    },
    {
      path: 'x7/position',
      name: 'VirtualControlX7Position',
      meta: {
        title: '车辆位置',
      },
      component: () => import('@/views/virtualControl/x7/position'),
    },
    {
      path: 'x7/state',
      name: 'VirtualControlX7State',
      meta: {
        title: '车辆状态',
      },
      component: () => import('@/views/virtualControl/x7/state'),
    },
    {
      path: 'x7/bluetoothSet',
      name: 'VirtualControlX7BluetoothSet',
      meta: {
        title: '蓝牙设置',
      },
      component: () => import('@/views/virtualControl/x7/bluetoothSet'),
    },
    {
      path: 'x7/set',
      name: 'VirtualControlX7Set',
      meta: {
        title: '控车设置',
      },
      component: () => import('@/views/virtualControl/x7/set'),
    },
    {
      path: 'x7/temperatureSet',
      name: 'VirtualControlX7TemperatureSet',
      meta: {
        title: '控车设置',
      },
      component: () => import('@/views/virtualControl/x7/temperatureSet'),
    },
  ],
};
